



























































import { Component, Vue } from "vue-property-decorator";
import Load from "@/components/Load.vue";
import LoadModal from "@/components/LoadModal.vue";
import WarehouseSelection from "@/components/WarehouseSelection.vue";
import EquipGroupSelection from "@/components/EquipGroupSelection.vue";
import StatusTenderSelection from "@/components/StatusTenderSelection.vue";
import SnackbarConnection from "@/components/SnackbarConnection.vue";
import TenderDispath from "@/components/TenderDispath/TenderDispath.vue";
import { actions, getters, mutations } from "@/observables";
const IS_PROD = process.env.NODE_ENV === "production";

@Component({
  components: {
    Load,
    WarehouseSelection,
    EquipGroupSelection,
    StatusTenderSelection,
    LoadModal,
    SnackbarConnection,
    TenderDispath
  }
})
export default class TenderMixOperator extends Vue {
  propsResolved = false; // indica se recebeu as props do consumidor (production)
  // Pseudo props recebidas via postMessage do consumidor
  cdCliente = 100012; //41
  cdUnidadeRegional = [1]; //"23,25"
  locale = IS_PROD ? (process.env.VUE_APP_I18N_LOCALE as string) : "en-us";
  grupo = 1; // indica para qual grupo as requests seram feitas (stack v2)
  urlSgp = "http://localhost:4445"; // urlSgp = "https://sgp-growmark-api.saas-solinftec.com";
  token = process.env.VUE_APP_TOKEN as string;
  loadsFiltered = [] as Array<Load.Load>;
  isOpenLoadModal = false;
  isOpenTenderDispath = false;
  tenderSelected = null;
  loadsInterval = 0;
  timerLoadsOfflineInterval = 0;
  environmentStage: "P" | "H" | "D" = "P"; // Indica se o ambiente é P -> Produção, H -> Homologação, D -> Development

  /* Computed */
  get loads() {
    const loads = getters.getLoads();
    const warehouse = getters.getWarehouseSelected();
    const equipGroup = getters.getEquipGroupSelected();
    const status = getters.getStatusTenderSelected();

    return loads.filter(
      (load: Load.Load) =>
        (warehouse.id ? load.facility.id === warehouse.id : true) && // filtrar pela warehouse
        (equipGroup.id ? load.configuracaoId === equipGroup.id : true) && // filtrar pelo grupo de equipamento
        (status.id !== -1 && status.id !== undefined ? load.accept === status.type : true) // Filtrar pelo estado do tender
    );
  }

  get loading() {
    return getters.getProgressLinear();
  }

  /* Methods */
  async setObservablesData() {
    actions.showProgress();
    try {
      await Promise.all([
        actions.fetchLoads(),
        actions.fetchWirehouse(),
        actions.fetchEquipGroups()
      ]);
      this.requestLoadsInterval();
    } catch (err) {
      console.error(err);
    } finally {
      actions.hideProgress();
    }
  }

  openLoadModal(tenderId = null) {
    this.tenderSelected = tenderId;
    this.isOpenLoadModal = true;
  }

  openSingleTender() {
    this.isOpenTenderDispath = true;
  }

  onCloseLoadModal() {
    this.isOpenLoadModal = false;
  }

  pipeline(): void {
    mutations.setUrlSgp(this.urlSgp);
    mutations.setToken(this.token);
    mutations.setCdCliente(this.cdCliente);
    mutations.setGrupo(this.grupo);
    mutations.setUnidade(this.cdUnidadeRegional);
    mutations.setLocale(this.locale);
    mutations.setEnvironmentStage(this.environmentStage);
    this.$i18n.locale = this.locale;
    mutations.setAxios();
    this.propsResolved = true;
  }

  checkPostedMessage(data?: TenderMixOperator.Props): boolean {
    return (
      typeof data?.cdCliente === "number" &&
      Array.isArray(data?.cdUnidadeRegional) &&
      data?.cdUnidadeRegional.length > 0 &&
      data?.cdUnidadeRegional.every(unidade => typeof unidade === "number") &&
      typeof data?.token === "string" &&
      typeof data?.grupo === "number" &&
      typeof data?.locale === "string" &&
      typeof data?.urlSgp === "string" &&
      typeof data?.offsetHeight === "string" &&
      typeof data?.environmentStage === "string"
    );
  }

  onWindowMessage(e: MessageEvent) {
    try {
      const message = typeof e.data === "string" ? JSON.parse(e.data) : e.data;
      if (message?.type === "props" && this.checkPostedMessage(message?.data)) {
        const {
          cdCliente,
          cdUnidadeRegional,
          token,
          grupo,
          locale,
          urlSgp,
          environmentStage
        } = message.data as TenderMixOperator.Props;
        this.cdCliente = cdCliente;
        this.cdUnidadeRegional = cdUnidadeRegional;
        this.token = token;
        this.urlSgp = urlSgp;
        this.grupo = grupo;
        this.locale = locale;
        this.environmentStage = environmentStage;
        // this.offsetHeight = offsetHeight;
        // console.log("message received", message?.data);
        parent.window.postMessage("message received", "*");
        this.propsResolved = false;
        this.pipeline();
        this.setObservablesData();
      }
    } catch (e) {
      console.error(e);
    }
  }

  async requestLoadsInterval() {
    this.loadsInterval = window.setInterval(() => {
      actions.fetchLoads();
    }, 1000 * 30);
  }

  closeRequestLoadsInterval() {
    if (window) {
      clearInterval(this.loadsInterval);
    }
  }

  initNetworkEvents() {
    window.addEventListener("offline", () => {
      this.initTimerLoadsOffline();
      actions.offConnection();
    });
    window.addEventListener("online", () => {
      this.stopTimerLoadsOffline();
      actions.onConnection();
    });
  }

  initTimerLoadsOffline() {
    this.timerLoadsOfflineInterval = window.setInterval(() => {
      this.decrementMinute();
    }, 1000 * 60);
  }

  stopTimerLoadsOffline() {
    if (window) {
      clearInterval(this.timerLoadsOfflineInterval);
    }
    actions.fetchLoads();
  }

  decrementMinute() {
    const loads = getters.getLoads().filter(load => !!load.route);
    for (const load of loads) {
      load.route.duration = load.route.duration >= 60 ? load.route.duration - 60 : 0;
    }
    mutations.setLoads(loads);
  }

  /* Hooks */
  created() {
    // se for production espera os valores do consumidor
    // if (IS_PROD) {
    parent.window.postMessage("solinftec-pwa-tender-mix-operator:loaded", "*");
    window.addEventListener("message", this.onWindowMessage, false);
    // } else {
    //   this.pipeline();
    // }
    this.initNetworkEvents();
  }

  beforeDestroy() {
    // if (IS_PROD) {
    window.removeEventListener("message", this.onWindowMessage, false);
    // }
    this.closeRequestLoadsInterval();
  }
}
